module.exports = __webpack_public_path__ + "static/img/supplier.dc351655.png";